import React, {Fragment, useEffect, useState} from "react";
import {TableV2} from "@q4us-sw/q4us-ui/lib/TableV2";
import {fetchDirectMessageAttachment, getFeConfig, visualizeLoad} from "../api/api";
import {Button, Col, PageHeader, Row, Tag} from "antd";
import {useHistory} from "react-router-dom";
import {MapToFilter} from "../utils/mappings";
import {DownloadOutlined, EditOutlined} from "@ant-design/icons";
import {MAIL_STATUS} from "../utils/constants";
import {TableFilter} from "../component/filters/TableFilter";
import "../styles/Em.css";
import {Auth} from "@q4us-sw/q4us-ui";
import jwt from "jsonwebtoken";

const Header = () => {
    const history = useHistory()

    const fetchData = async (values, page = {})=>{
        const filters = MapToFilter(values)
        return await visualizeLoad({
            tableName: 'direct_message',
            orderBy: ['id desc'],
            filter:[...filters],
            page: { size: page.size || 100, from: ((page.current || 1) - 1) * (page.size || 100)}
        }) || {}
    }

    return <div className={'direct-message-header'}>
        <Row>
            <Col span={12}>
                <PageHeader title={'Direct Messages'}/>
            </Col>
            <Col span={12}>
                <Button className={'margin-twenty'} onClick={() => {
                    history.push({
                        pathname: '/view/add-message',
                        state: {initialFieldData: {}}
                    })
                }}>New Message</Button>
            </Col>
        </Row>
        <TableFilter schema={'direct_message_filter'} fetch={fetchData}/>
    </div>
}

const DirectMessage = () => {
    const [emObj, setEMObj] = useState()
    const [user, setUser] = useState()

    const history = useHistory()

    const fetchData = async (values, page = {}) => {
        const filters = MapToFilter(values)
        return await visualizeLoad({
            tableName: 'direct_message',
            orderBy: ['id desc'],
            filter: [...filters],
            page: {size: page.size || 100, from: ((page.current || 1) - 1) * (page.size || 100)}
        }) || {}
    }

    const loadEMs = async () => {
        const {data: {rows = []} = {}} = await visualizeLoad({tableName: 'enums', filter: [{name: 'type', value: 'em_name'}]})
        setEMObj(Object.fromEntries(rows[0]?.values || []))
    }

    const loadUser = async () => {
        const {sub} = jwt.decode(Auth.token)
        setUser(sub)
    }

    useEffect(() => {
        loadEMs()
    }, [])

    useEffect(() => {
        loadUser()
    }, [])

    return <TableV2
        schema={'direct_message'}
        header={<Header/>}
        fetchConfig={(schema) => {
            return getFeConfig(schema)
        }}
        fetchData={request => {
            return fetchData(request.options.filter || {}, request.page)
        }}
        customRenderer={{
            status: (value) => {
                const colorMap = Object.freeze({
                    draft: 'default',
                    sending: 'warning',
                    sent: 'success'
                })
                return <Tag color={colorMap[value]}>{value.substring(0, 1).toUpperCase()+value.substring(1)}</Tag>
            },
            em_id: (value) => {
                return <Fragment>
                    {value?
                        value?.map(emId => <Tag>{emObj && emObj[emId.toString()]}</Tag>)
                        :<Tag color="#2db7f5">All E Merchants</Tag>}
                </Fragment>
            },
            oid: (value, {filename}) => {
                return <Button
                    icon={<DownloadOutlined />}
                    disabled={!value}
                    onClick={async () => {
                        return fetchDirectMessageAttachment(value, filename)
                    }}
                >Download</Button>
            },
            action: (value, row) => {
                return <Button
                    disabled={row.status !== MAIL_STATUS.DRAFT || user!==row.user_id}
                    icon={<EditOutlined/>}
                    onClick={() => {
                        history.push({
                            pathname: '/view/add-message',
                            state: {initialFieldData: row}
                        })
                    }}
                >Edit</Button>
            }
        }}
        scroll={{y: 'calc(90vh - 200px)', x: 'max-content' }}
    />
}

export default DirectMessage